<button
	[class.invisible]="!showBack"
	[icon]="backIcon ? backIcon : 'fas fa-arrow-left'"
	(click)="goBack.emit()"
	class="flex-none p-button-primary-transparent"
	pButton
></button>
<div [class]="contentClass" class="flex-auto">
	<ng-content></ng-content>
</div>
